import { FC, useState } from 'react';
import { Image } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import styles from './Avatar.module.scss';

type AvatarParams = {
  avatarURL?: string | null;
};

export const Avatar: FC<AvatarParams> = ({ avatarURL = '' }) => {
  const [imgLoadingError, setImgLoadingError] = useState(false);

  return (
    <div className={styles.avatar}>
      {Boolean(avatarURL) === false || imgLoadingError ? (
        <TeamOutlined />
      ) : (
        <Image
          className={styles.avatar__img}
          alt="Group avatar"
          src={avatarURL || undefined}
          onError={() => setImgLoadingError(true)}
        />
      )}
    </div>
  );
};
